import * as Redux from 'redux';
import { ReduxAction, SimpleResponse } from '../app/app.types';
import { REVERT_TO_INITIAL_STATE, REVERT_TO_INITIAL_STATE_EXCEPT_AUTH } from '../app/app.const';
import { PackageState, PackageActionTypes, PackageEntity } from './Types';
import { INITIAL_PACKAGE_STATE, CREATE_PACKAGE, GET_PACKAGES, UPDATE_PACKAGE, GET_PACKAGE_REPORT } from './Constants';

export const packageReducer: Redux.Reducer<PackageState> = (
  packageState: PackageState = INITIAL_PACKAGE_STATE,
  action: ReduxAction<PackageActionTypes, SimpleResponse<PackageEntity>>
): PackageState => {
  
  switch (action.type) {

    case `${GET_PACKAGE_REPORT}_FULFILLED`:
      return { ...packageState,
        statusCode: action.payload.statusCode,
        packageReport: {
          validCheckins: action.payload.body.validCheckins,
          noShows: action.payload.body.noShows,
          details: action.payload.body.details
        }
      };
    case `${CREATE_PACKAGE}_FULFILLED`:
      return {...packageState,
        statusCode: action.payload.statusCode,
        createdPackage: action.payload.body.entity
      };

    case `${GET_PACKAGES}_FULFILLED`:
      return {...packageState,
        statusCode: action.payload.statusCode,
        packages: action.payload.body.list
      };

    case `${UPDATE_PACKAGE}_FULFILLED`:
      return {...packageState,
        statusCode: action.payload.statusCode,
        createdPackage: action.payload.body.entity
      };

    default:
      return {
        ...packageState
      };
      
  }

};

export default packageReducer;


// WEBPACK FOOTER //
// ./src/mms-package/Reducer.tsx